export default "__VITE_ASSET__D0pR3SrJ__"